import ActionArea from "../../components/ActionArea"
import Head from "../../components/Head"
import { useNavigate } from "react-router-dom"
import SmartSearch from "../../components/UI/SmartSearch"
import { useEffect, useState } from "react"
import cashiersStatus from "../../utils/cashiersStatus"
import SelectInput from "../../components/UI/SelectInput"
import { Col, message, Modal, Row } from "antd"
import {
  EditOutlined,
  EyeInvisibleOutlined,
  EyeTwoTone,
} from '@ant-design/icons'
import List from "../../components/List"
import { createOrUpdateCashier, getCashierById, getCashiersList, updateCashierStatus } from "../../services/cashiers"
import Button from "../../components/UI/Button"
import { getPermission } from "../../services/permisssion"
import permissionType from "../../utils/permissionType"
import React from "react"
import direction from "../../utils/filterDirectionOrder"
import { notificationError} from "../../services/notification"
import { useLoading } from "../../context/LoadingProvider/useLoading"
import { useListRecord } from "../../context/ListRecordProvider/useListRecord"
import { IParams } from "../../context/ListRecordProvider/types"
import { sendSystemLog, useAuth } from "../../context/AuthProvider/useAuth"
import { InputMode } from "../../enums/inputTypeEnum"
import Input from "../../components/UI/Input";
import Column from "antd/lib/table/Column"
import { findRelativeStatus } from "../../utils/objectUtils"

const selectOptions = [
  {name: 'All', value: 'All'},
  {name: cashiersStatus.active, value: cashiersStatus.active},
  {name: cashiersStatus.inactive, value: cashiersStatus.inactive},
]
const accessStatus = {
  true: "true",
  false: "false",
}

function Cashiers(props: {accessLevel: string}) {
  const {canEdit} = useAuth()
  const log = {
    log_type: 'visited',
    log_object: 'cashier'
  }
  const listRecord = useListRecord()
  const record = listRecord.getRecord('cashiersList')
  const urlParams = new URLSearchParams(window.location.search);
  const useRecord = urlParams.get('useRecord')
  const history = useNavigate()
  const loading = useLoading()
  
  const [search, setSearch] = useState('')
  const [params, setParams] = useState<IParams>({
    status: selectOptions[0].value,
    fieldOrder: '',
    directionOrder: '',
    id: null,
    name: '',
    type: '',
  })
  const [validSearch, setValidSearch] = useState(false)
  const [cashiersList, setCashiersList] = useState({
    count: 0,
    page: null,
    perpage: 0,
    list: [],
  })
  const [modalVisible, setModalVisible] = useState(false)
  const [modalVisiblePassword, setModalVisiblePassword] = useState(false)
  const [paramsToDelete, setParamsToDelete] = useState({id: '', status: ''})
  const [showPassword, setShowPassword] = useState(false)
  const statusSelectOptions = [
    { label: cashiersStatus.active, value: cashiersStatus.active },
    { label: cashiersStatus.inactive, value: cashiersStatus.inactive },
  ]
  const enableOptions = [
    { label: 'yes', value: 'yes' },
    { label: 'no', value: 'no' }
  ]
  const [form, setForm] = useState({
    id: null,
    locationId: "",
    login: "",
    password: "",
    name: "",
    status: cashiersStatus.active,
    canAccessPeriodSummary: enableOptions[0].value,
    canViewDrawerReport: enableOptions[0].value,
    confirm: ""
  })

  useEffect(() => {
    sendSystemLog(log)
  }, [])

  useEffect(() => {
    (async() =>{
      loading.addLoading()
      if(record && useRecord) {
        const response = await getCashiersList({
          status: record.status,
          [`${record.type}Id`]: record.id,
        })
        setCashiersList(response)
        setParams(record)
        setSearch(record.name)
      }
      loading.removeLoading()
    })()
  }, [])

  const onRefresh = async (order?: string, directionparam?: string) => {
    if(!validSearch || !params.id) return notificationError("Please select a valid search")
    loading.addLoading()
    let requestParams = {
      status: params.status,
      [`${params.type}Id`]: params.id,
      fieldOrder: '',
      directionOrder: ''
    }
    if(order && directionparam) {
      requestParams = {
        ...requestParams,
        fieldOrder: order || '',
        directionOrder: directionparam === 'ascend' ? direction.asc : direction.desc,
      }
      setParams({
        ...params,
        fieldOrder: order || '',
        directionOrder: directionparam === 'ascend' ? direction.asc : direction.desc,
      })
    }
    const response = await getCashiersList(requestParams)
    setCashiersList(response)
    listRecord.addRecord('cashiersList', params)
    loading.removeLoading()
  }

  const openChangeStatusModal = (id: string, status: string) => {
    (async () => {
        const response = await getCashierById({ id })
        if (response && response.id) {
          setForm({
            id: response.id,
            locationId: response.locationId,
            login: response.login,
            password: "",
            name: response.name,
            status: findRelativeStatus(response.status, statusSelectOptions),
            canAccessPeriodSummary: response.canAccessPeriodSummary === "true" ? 'yes' : 'no',
            canViewDrawerReport: response.canViewDrawerReport === "true" ? 'yes' : 'no',
            confirm: ""
          })
        }
      })()
    const cashier = {
      id,
      status: status === cashiersStatus.active ? cashiersStatus.inactive : cashiersStatus.active
    }
    setParamsToDelete(cashier)
    if(status === cashiersStatus.active) {
      setModalVisible(true)
    } 
    else {
      setModalVisiblePassword(true)
    }
  }

  const changeCashierStatus = async () => {
    if(paramsToDelete.status === cashiersStatus.active) {
      if (!form.password && !paramsToDelete.id) {
        return notificationError('Please insert a password')
      }
      if (form.password && form.password.length < 4) {
        return notificationError('Could not activate Cashier. Password is too short (minimum is 6 characters)')
      }
      if (form.password.length > 128) {
        return notificationError('Could not activate Cashier. Password is too long (max is 128 characters)')
      }
      if (form.confirm !== form.password) {
        return notificationError("Could not activate Cashier. Password must match password confirmation.")
      }
      let response = { success: true }
      response = await createOrUpdateCashier(form)
      if (!response.success) {
        return notificationError("Error updating and activating Cashier.")
      }
    }
    
    await updateCashierStatus(paramsToDelete)
    await onRefresh()
    setModalVisible(false)
    setModalVisiblePassword(false)
  }

  
  const onChangeOrder = (order: {column: any, field: string, order: string| undefined}) => {
    if(order.column) return onRefresh(order.field, order.order)
    return onRefresh()
  }

    const onFormChange = (val: string, name: string) => {
      setForm({
        ...form,
        [name]: val
      })
    }

  const verifyPassword = () => {
    if (paramsToDelete.status === cashiersStatus.active) {
      if (!form.password || !form.confirm) return false
      if (form.password && form.password.length < 4) return false
      if (form.password.length > 128) return false
      return true
    }
    return true
  }

  const getAccessStatusLabel = (status: string) => {
    if(status === accessStatus.true) {
      return <div className="cashiers__table__status cashiers__table__status--active">Yes</div>
    } 
    if(status === accessStatus.false ) {
      return <div className="cashiers__table__status cashiers__table__status--inactive">No</div>
    }
  }
  
  const getStatusLabel = (status: string) => {
    if(status === cashiersStatus.active) {
      return <div className="cashiers__table__status cashiers__table__status--active">{status}</div>
    } 
    if(status === cashiersStatus.inactive ) {
      return <div className="cashiers__table__status cashiers__table__status--inactive">{status}</div>
    }
  }

  const getActionButtons = (value: any, index: number) => {
    return(
      <div className="cashiers__table__actions">
        <Button 
          onClick={() => openChangeStatusModal(value.id, value.status)}
          style={{backgroundColor: value.status === cashiersStatus.active ? '#dd5600' : '#669533', width: 91}}
          type='primary'
          disabled={!canEdit}
        >
          <p id={'change-status-' + index} >{value.status === cashiersStatus.active ? 'Deactivate' : 'Activate'}</p>
        </Button>
        <Button 
          onClick={() => history(`../cashiers/new/${value.id}`)}
          type='primary'
          style={{backgroundColor: '#2fa4e7'}}
          disabled={!canEdit}
        >
          <EditOutlined  id={'edit-page-' + index} style={{ fontSize: '16px', color: '#FFF' }} />
        </Button>
      </div>
    )
  }


  return (
    <div className="cashiers">
      <Modal 
        title="The selected cashier will change. Are you sure?"
        open={modalVisible}
        onOk={changeCashierStatus} 
        onCancel={
          () => {
            setModalVisible(false)
          }
        }
      />
      <Modal
        title="The selected cashier will change. Are you sure?"
        open={modalVisiblePassword}
        onOk={changeCashierStatus}
        onCancel={
          () => {
            setModalVisiblePassword(false)
          }
        }
        okButtonProps={{ disabled: !verifyPassword() }}
        cancelButtonProps={{ disabled: false }}
      >
        <Row>
            <Input
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => onFormChange(e.target.value, 'password')}
              value={form.password}
              label='Password'
              placeholder='Password'
              inputMode={showPassword ? InputMode.TEXT : InputMode.PASSWORD}
              innerProps={{ id: 'new-cashier-password' }}
            />
        </Row>
        <Row align="middle">
          <Col>
            <Input
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => onFormChange(e.target.value, 'confirm')}
              value={form.confirm}
              label='Password Confirmation*'
              placeholder='Password Confirmation'
              inputMode={showPassword ? InputMode.TEXT : InputMode.PASSWORD}
              innerProps={{ id: 'new-cashier-password-confirm' }}
            />
          </Col>
          <Col>
            <Button style={{ width: 30, display: 'block' }} onClick={() => setShowPassword((prevState) => !prevState)}>
              {!showPassword &&
                <EyeInvisibleOutlined />
              }
              {showPassword &&
                <EyeTwoTone />
              }
            </Button>
          </Col>
        </Row>
      </Modal>
      <Head
         id={'cashiers-button'}
        title="All Cashiers" 
        buttonText={'New Cashier'} 
        buttonAction={ () => history('../cashiers/new')}
        disabled={!canEdit} 
      />
      <meta name="viewport" content="width=device-width, initial-scale=.75"/>

      <ActionArea innerProps={{id: 'cashiers_refresh'}} buttonAction={onRefresh} buttonText={'Search'} disabled={!validSearch}>
        <div className="cashiers__action-area">
          <SmartSearch
            innerProps={{id:'cashiers_smart-search'}}
            value={search}
            onChange={(e: string) => setSearch(e)}
            onValidSearch={setValidSearch}
            label='Smart Search'
            status="active"
            triggerWith={record?.name || ''}
            searchBy={['location', 'cashier']}
            onObjValueChange={(e: any) => setParams({...params, ...e})}
            autoFocus
          />
          <SelectInput
            innerProps={{id: 'cashiers_status'}}
            options={selectOptions} 
            label='Status'
            onSelectChange={(e) => setParams({...params, status: e?.value ? e.value : e})}
            value={params.status}
          />
        </div>
      </ActionArea>
      <List
        pagination={false}
        onChange={(selectedRowKeys, selectedRows, order) => onChangeOrder(order)}
        rows={cashiersList.list}
        columns={[
          {
            title: 'Login',
            dataIndex: 'login',
            key: 'login',
            render: (value: string) => value,
            width: 150,
            sorter: true,
          },
          {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (value: string) => value,
            width: 150,
            sorter: true,
          },
          {
            title: 'Location',
            dataIndex: 'locationName',
            key: 'locationName',
            render: (value: string) => value,
            width: 150,
            sorter: true,
          },
          {
            title: 'Can Access Period Summary',
            dataIndex: 'canAccessPeriodSummary',
            key: 'canAccessPeriodSummary',
            render: (value: string) => getAccessStatusLabel(value),
            width: 75,
            sorter: true,
          },
          {
            title: 'Can Edit Drawer Records',
            dataIndex: 'canViewDrawerReport',
            key: 'canViewDrawerReport',
            render: (value: string) => getAccessStatusLabel(value),
            width: 75,
            sorter: true,
          },
          {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (value: string) => getStatusLabel(value),
            width: 75,
            sorter: true,
          },
          {
            title: 'Actions',
            dataIndex: '',
            key: 'actions',
            render: (value: any, record: any, index: number) => getActionButtons(value, index),
            width: 50,
          },
        ]}
      />
    </div>
  )
}

export default Cashiers
